import { render } from "./SingleThought.vue?vue&type=template&id=df56608c&scoped=true"
import script from "./SingleThought.vue?vue&type=script&lang=js"
export * from "./SingleThought.vue?vue&type=script&lang=js"

import "./SingleThought.vue?vue&type=style&index=0&id=df56608c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df56608c"]])

export default __exports__